<script setup>
const props = defineProps({
    title: { type: String, default: '' },
    icon: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    hidden: { type: Boolean, default: false } // default => visible
});
const emit = defineEmits(['click']);

const handleClick = (event) => {
    emit('click', event);
};
</script>

<template>
    <v-btn
        v-if="!props.hidden"
        @click="handleClick"
        variant="text"
        :prepend-icon="props.icon"
        :disabled="props.disabled"
        :class="{ removeMargin: props.title ? false : true }"
        density="compact"
        size="small"
        v-bind="$attrs"
    >
        <template v-slot:prepend>
            <v-icon color="primary" size="medium"></v-icon>
        </template>
        <div>{{ $t(title) }}</div>
    </v-btn>
</template>

<style lang="scss" scoped>
.v-btn:hover {
    background-color: rgba(var(--v-theme-primary), var(--v-activated-opacity));
}

.removeMargin {
    :deep(.v-btn__prepend) {
        margin: 0 !important;
    }
}

:deep(.v-btn__content) {
    font-size: 0.75rem; /* Reduced to 12px */
    letter-spacing: 0.025em;
}

:deep(.v-icon) {
    font-size: 1.25rem !important; /* 20px */
}
</style>
